import React, { useCallback, useState } from "react";
import CustomBreadcumbs from "../../../component/atoms/custom-breadcumbs";
import TitlePages from "../../../component/atoms/title-pages";
import { SubTitleTab, TitleTab } from "../../../component/page-components";
import { DatePicker, message } from "antd";
import MSSDepot from "./__components/mss-depot/MSSDepot";
import { useDispatch, useSelector } from "react-redux";
import DDSAllStatus from "../../../component/dds/all-status";
import { IconExport } from "../../../asset";
import dayjs from "dayjs";
import { EXPORT_ORDER_INVOICE } from "../../../api/contractAPI.api";
import { doExport } from "../../../api/baseAPI";
import NotifFailedExported from "../../../component/modal/NotifFailedExport";
import MultipleSelectOrderFrom from "../../../component/multiple-select/order-from";
import { setGlobalErrors } from "../../../store/reducer/globalErrors.reducers";

const MainInvoice = () => {
  const dispatch = useDispatch();

  const { token } = useSelector((state) => state.auth);

  const { globalDepotName } = useSelector((state) => state.globalMSS);

  const { globalAllStatus } = useSelector((state) => state.globalDDS);
  const { globalErrors } = useSelector((state) => state.globalErrors);
  const { valuesMultipleSelectOrderFrom } = useSelector(
    (state) => state.globalMultipleSelectValues
  );

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [messageFailed, setMessageFailed] = useState("");

  const validateExportAsPDF = useCallback(() => {
    const datas = {
      globalDepotName: [...globalDepotName],
      valuesMultipleSelectOrderFrom: [...valuesMultipleSelectOrderFrom],
      globalAllStatus,
      startDate,
      endDate,
    };

    const dataCheck = [
      "valuesMultipleSelectOrderFrom",
      "globalDepotName",
      "globalAllStatus",
      "startDate",
      "endDate",
    ];

    function arePropertiesValid(obj, propertyNames) {
      return propertyNames.every((propertyName) =>
        isPropertyValid(obj, propertyName)
      );
    }

    function isPropertyValid(obj, propertyName) {
      return (
        obj.hasOwnProperty(propertyName) &&
        obj[propertyName] !== undefined &&
        obj[propertyName] !== null &&
        obj[propertyName] !== "" &&
        !(Array.isArray(obj[propertyName]) && obj[propertyName].length === 0)
      );
    }

    const isValid = arePropertiesValid(datas, dataCheck);
    return isValid;
  }, [
    endDate,
    globalAllStatus,
    globalDepotName,
    valuesMultipleSelectOrderFrom,
    startDate,
  ]);

  const setMandatory = useCallback(() => {
    const depots = [...globalDepotName];
    const orderFromList = [...valuesMultipleSelectOrderFrom];
    const statusPaid = globalAllStatus;

    let errors = {};
    if (orderFromList && orderFromList.length === 0) {
      Object.assign(errors, { order_from: "This field is required!" });
    }
    if (depots && depots.length === 0) {
      Object.assign(errors, { depot: "This field is required!" });
    }
    if (statusPaid === null) {
      Object.assign(errors, { status: "This field is required!" });
    }
    if (startDate === "" || endDate === "") {
      Object.assign(errors, { date_period: "This field is required!" });
    }
    dispatch(setGlobalErrors(errors));
  }, [
    dispatch,
    endDate,
    globalAllStatus,
    globalDepotName,
    startDate,
    valuesMultipleSelectOrderFrom,
  ]);

  const handleExportAsPDF = useCallback(async () => {
    if (validateExportAsPDF()) {
      const depot = [...globalDepotName];

      const depotId =
        depot && depot.length > 0 && !depot.includes(-1)
          ? depot?.map((el) => el.id)
          : [-1];

      const orderFrom = [...valuesMultipleSelectOrderFrom];
      const orderFromList =
        orderFrom && orderFrom.length === 0
          ? {
              order_from: {
                list: [],
                exclude: false,
              },
            }
          : {
              order_from: {
                list: orderFrom.map((el) => el?.id),
                exclude: false,
              },
            };

      const payload = {
        ...orderFromList,
        depot_id: [...depotId],
        status: globalAllStatus ? globalAllStatus?.value : "",
        from_date: startDate,
        thru_date: endDate,
      };
      try {
        const res = await doExport(EXPORT_ORDER_INVOICE, token, payload);
        if (res?.status === 200) {
          const pdfBlob = new Blob([res?.data]);

          const url = window.URL.createObjectURL(pdfBlob);

          const tempLink = document.createElement("a");
          tempLink.href = url;
          tempLink.setAttribute("download", `billing_invoice.pdf`);

          document.body.appendChild(tempLink);
          tempLink.click();

          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(url);
          return;
        }
      } catch (error) {
        if (error?.response?.status === 400) {
          setIsFailedModalOpen(true);
          setMessageFailed(error?.message);
          return;
        }
        if (error?.response?.status === 500) {
          message.error("Internal Server Error");
          return;
        }
      }
    }
    setMandatory();
  }, [
    globalAllStatus,
    globalDepotName,
    valuesMultipleSelectOrderFrom,
    validateExportAsPDF,
    setMandatory,
    startDate,
    endDate,
    token,
  ]);

  const onChangeDatePeriod = useCallback(
    (evt) => {
      const errors = { ...globalErrors };
      if (errors?.date_period) {
        delete errors.date_period;
        dispatch(setGlobalErrors(errors));
      }

      const startDate = dayjs(evt[0]).format("YYYY-MM-DD");
      const endDate = dayjs(evt[1]).format("YYYY-MM-DD");
      setStartDate(startDate);
      setEndDate(endDate);
    },
    [dispatch, globalErrors]
  );

  return (
    <>
      <CustomBreadcumbs
        jmlLevel={2}
        menuLevel1={"Report"}
        menuLevel2={"Invoice"}
      />
      <TitlePages name={"Invoice"} />
      <div className="container-pages">
        <TitleTab title="Filter Report" />

        <div className="flex flex-col gap-2 w-[500px]">
          <div className="container-field">
            <SubTitleTab title={"Order From"} />
            <MultipleSelectOrderFrom />
          </div>
          {globalErrors && globalErrors?.order_from ? (
            <span className="text-red-100 font-bold text-sm font-roboto">
              {globalErrors?.order_from}
            </span>
          ) : (
            false
          )}
          <div className="container-field">
            <SubTitleTab title="Depot Name" />
            <MSSDepot />
          </div>
          {globalErrors && globalErrors?.depot ? (
            <span className="text-red-100 font-bold text-sm font-roboto">
              {globalErrors?.depot}
            </span>
          ) : (
            false
          )}
          <div className="container-field">
            <SubTitleTab title="All Status" />
            <DDSAllStatus />
          </div>
          {globalErrors && globalErrors?.status ? (
            <span className="text-red-100 font-bold text-sm font-roboto">
              {globalErrors?.status}
            </span>
          ) : (
            false
          )}
          <div className="container-field">
            <SubTitleTab title={"Date Period"} />
            <DatePicker.RangePicker
              onChange={onChangeDatePeriod}
              size="large"
              maxDate={dayjs(new Date())}
            />
          </div>
          {globalErrors && globalErrors?.date_period ? (
            <span className="text-red-100 font-bold text-sm font-roboto">
              {globalErrors?.date_period}
            </span>
          ) : (
            false
          )}
        </div>
      </div>
      <div className="btn-container">
        <button className="btn-next flex gap-4" onClick={handleExportAsPDF}>
          <img src={IconExport} alt="icon-export" />
          Export as PDF
        </button>
      </div>
      <NotifFailedExported
        visible={isFailedModalOpen}
        message={messageFailed}
        action={() => {
          setIsFailedModalOpen(false);
        }}
      />
    </>
  );
};

export default MainInvoice;
